import { render, staticRenderFns } from "./mergeSessionConfirm.vue?vue&type=template&id=208cd458"
import script from "./mergeSessionConfirm.vue?vue&type=script&lang=js"
export * from "./mergeSessionConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports